import React from 'react';
import { Clock, LogOut } from 'lucide-react';

export const DashboardHeader = ({ minutesRemaining, userName, onLogout }) => (
  <header className="bg-[#0d1117] border-b border-gray-800 px-6 py-4">
    <div className="max-w-7xl mx-auto flex items-center justify-between">
      <a href="/" className="text-xl font-bold text-white tracking-tight">
        AI<span className="text-teal-400">CONNEQTORS</span>
      </a>
      <div className="flex items-center gap-4">
        <div className="hidden md:flex items-center gap-2 px-3 py-1.5 bg-teal-400/10 border border-teal-400/30 rounded-full">
          <Clock className="w-4 h-4 text-teal-400" />
          <span className="text-teal-400 text-sm font-medium" data-testid="minutes-remaining">
            {minutesRemaining} min remaining
          </span>
        </div>
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-full bg-gradient-to-br from-teal-400 to-teal-600 flex items-center justify-center text-white font-bold text-sm">
            {userName?.charAt(0) || 'U'}
          </div>
          <span className="text-gray-300 text-sm hidden md:block">{userName || 'User'}</span>
        </div>
        <button
          onClick={onLogout}
          className="flex items-center gap-2 text-gray-400 hover:text-red-400 transition-colors"
          data-testid="logout-btn"
        >
          <LogOut className="w-5 h-5" />
        </button>
      </div>
    </div>
  </header>
);
